export default "__VITE_ASSET__D$cHDYha__"